import { render } from "./Clientemodal.vue?vue&type=template&id=5a92fb18"
import script from "./Clientemodal.vue?vue&type=script&lang=js"
export * from "./Clientemodal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\frontend.avicola\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__